export default __webpack_public_path__ + "static/media/logo.bf68c5bf.svg";